exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidetable[data-v-cf8a2ffa]{\n\ttable-layout:fixed;\n\tbackground-color: #ffffff;\n\tborder-collapse: collapse;\n\tborder: 0px solid black;\n\tempty-cells: show;\n}\n.lefttable[data-v-cf8a2ffa]{\n    flex-grow:1;\n    margin-right:16px;\n}\n.righttable[data-v-cf8a2ffa]{\n\tflex:0 0 35%;\n}\n.parentinvoice[data-v-cf8a2ffa] {\n\tpadding:0px 5px 0px 5px;\n\tfont-size:15px;\n\tfont-weight: bold;\n\tcolor:#000000;\n\tbackground-color:#cfcfff;\n\tborder-radius: 5px;\n\tborder:2px solid #2929d6;\n\tmargin:0px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cf8a2ffa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_9.vue
// module id = 767
// module chunks = 0